import { initialState } from '@ispm-client/modules/bpmn-modeler/store/state';
import {
    ModelerStateActions,
    StateActionTypes
} from '@ispm-client/modules/bpmn-modeler/store/actions/modeler-state.actions';
import { PathwaysAuthoringState } from '@ispm/shared/constants/pathways-authoring-state';

/**
 * Created By Elia Rohana on 2/12/19
 */
export function modelerState(state = initialState.modelerState, action: ModelerStateActions): PathwaysAuthoringState {
    switch (action.type) {
        case StateActionTypes.MODELER_STATE: {
            return action.payload.modelerState;
        }
        default: {
            return state;
        }
    }
}
